import { Container } from "components";
import Loading from "components/atoms/Loading/Loading";
import { AccountModule } from "components/molecules/Account";
import React, { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "store/hooks";
import { setCurrentPage } from "store/slices/ui.slice";

export const MyAccount: React.FC = () => {
  const dispatch = useAppDispatch();
  const isLoading = useAppSelector((state) => state.user.updateUser.isLoading);
  useEffect(() => {
    window.analytics.page("Account Settings");
    dispatch(setCurrentPage("account"));
  }, []);
  if (isLoading)
    return (
      <div style={{ position: "absolute", width: "100%", height: "100vh" }}>
        <Loading />
      </div>
    );
  return (
    <Container className="p-10 overflow-y-auto items-center">
      <AccountModule />
    </Container>
  );
};
